package com.gstechnovos.sanative.pages

import androidx.compose.runtime.Composable
import com.gstechnovos.sanative.components.widgets.SystemMessageCard
import com.gstechnovos.sanative.utils.LocalBreakpoint
import com.gstechnovos.sanative.utils.Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Page("/404")
@Composable
fun NotFoundPage() {
    val breakpoint = LocalBreakpoint.current
    val isDesktop = breakpoint >= Res.Breakpoints.MD

    // Full-screen low-glare background (color-bg-base)
    Box(
        modifier = Modifier
            .fillMaxSize()
            .minHeight(100.vh)
            .backgroundColor(Color.rgb(0xF4F6F0)),
        contentAlignment = Alignment.Center
    ) {
        SystemMessageCard {
            // Visual Indicator pulled from App Constants
            Image(
                src = Res.Images.NotFound.NOT_FOUND_IMG,
                description = "Page Not Found",
                modifier = Modifier
                    .size(if (isDesktop) 100.px else 72.px)
                    .margin(bottom = 24.px)
            )

            // H2 Heading (Deep Slate)
            SpanText(
                text = "Page not found",
                modifier = Modifier
                    .color(Color.rgb(0x111827))
                    .fontSize(if (isDesktop) 40.px else 32.px) // Responsive typography
                    .fontWeight(FontWeight.Bold)
                    .margin(bottom = 16.px)
                    .textAlign(TextAlign.Center)
            )

            // Body Standard pulled from Errors strings
            SpanText(
                text = Res.Strings.Errors.NOT_FOUND,
                modifier = Modifier
                    .color(Color.rgb(0x4B5563))
                    .fontSize(16.px)
                    .lineHeight(1.6)
                    .margin(bottom = 32.px)
                    .textAlign(TextAlign.Center)
            )

            // Primary Accessible Button mapped to Routes and Buttons strings
            Link(
                path = Res.Strings.Routes.HOME,
                text = Res.Strings.Buttons.RETURN_HOME,
                modifier = Modifier
                    .backgroundColor(Color.rgb(0x008080))
                    .color(Colors.White)
                    .minHeight(56.px) // Strict neuro-accessibility touch target
                    .padding(leftRight = 32.px, topBottom = 16.px)
                    .borderRadius(12.px)
                    .fontWeight(FontWeight.SemiBold)
                    .textDecorationLine(TextDecorationLine.None)
            )
        }
    }
}